import "./panel.css";
import useTableData from "../tableContext/useTableData";
import TableFilterItem from "../tableFiterItem/TableFilterItem";
import {CloseOutlined} from "@ant-design/icons";
import {FilterProps} from "../tableTypes";
import Panel from "../../panel/Panel";

interface FiltersPanelProps {
    filters: any;
    isOpen: boolean;
}

const FiltersPanel = ({ isOpen }: FiltersPanelProps) => {
    const { filters, setIsFiltersPanelOpen } = useTableData();

    const closeFilters = () => {
        setIsFiltersPanelOpen(false);
    }

    return (
        <Panel isOpen={isOpen} onClose={closeFilters}>
            {filters?.map((filter: FilterProps) => <TableFilterItem key={`table-filter-${filter.filterKey}`} {...filter} />)}
        </Panel>
    );
}

export default FiltersPanel;